import { styled } from '@mui/system';

// inline-flex keeps the vertical margins from collapsing, like the former styled(Field)
export const StyledDateTimeField = styled('div')(({ theme }) => ({
  display: 'inline-flex',
  width: '100%',
  margin: theme.spacing(1, 0)
}));

export const ContactCnt = styled('div')(({ theme }) => ({
  display: 'grid',
  margin: theme.spacing(1, 0),
  gridGap: theme.spacing(2),
  gridTemplateAreas: '"company company" ". ."',
  [theme.breakpoints.down('sm')]: {
    gridTemplateAreas: '"company" "." "."'
  }
}));

export const companyFieldStyle = {
  gridArea: 'company'
};

export const FieldsCnt = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(1)} 0`,
  width: '100%'
}));

export const AddressLocationCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse'
  }
}));

export const AddressCnt = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between'
});

export const addressFieldStyle = theme => ({
  width: '48%',
  margin: `${theme.spacing(1)} 0`,
  '@media (max-width: 700px)': {
    width: '100%'
  }
});

export const DeviationFields = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1.5),
  '& > div': {
    position: 'relative',
    width: '48.5%'
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    '& > div': {
      width: '100%'
    }
  }
}));

export const ButtonGroupCnt = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    alignSelf: 'flex-end',
    margin: `${theme.spacing(1)} 0`
  }
}));

export const buttonGroupStyle = theme => ({
  margin: `${theme.spacing(1)} 0 0 ${theme.spacing(2)}`,
  [theme.breakpoints.down('sm')]: {
    alignSelf: 'flex-end',
    margin: `${theme.spacing(1)} 0`,
    '& button:nth-of-type(1)': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }
  }
});

export const GeofenceCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'start'
  }
}));

export const GeofenceTitle = styled('p')(({ theme }) => ({
  paddingRight: theme.spacing(1.5),
  margin: 0
}));

export const geofenceRadioControlStyle = theme => ({
  paddingRight: theme.spacing(0.5)
});

export const radioLabelStyle = {
  minWidth: 130
};

export const TimeFieldsContainer = styled('div')({});

export const TimeDeviationCnt = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  columnGap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    maxWidth: '285px',
    '&>*:nth-of-type(3)': {
      '& label': {
        paddingLeft: '28px !important',
        '&.MuiFormLabel-filled': {
          transform: 'translate(12px, 46px) scale(0.75) !important'
        },
        '&.Mui-focused': {
          transform: 'translate(12px, 46px) scale(0.75) !important'
        }
      }
    },
    '& label': {
      paddingLeft: '18px !important',
      marginTop: '3px !important',
      '&.MuiFormLabel-filled': {
        transform: 'translate(15px, 46px) scale(0.75) !important'
      },
      '&.Mui-focused': {
        transform: 'translate(15px, 46px) scale(0.75) !important'
      }
    }
  },
  '&>*:nth-of-type(3)': {
    '& label': {
      marginLeft: '-5px !important',
      '&.MuiFormLabel-filled': {
        transform: 'translate(28px, 46px) scale(0.75)',
        marginLeft: '-10px !important',
        marginTop: '3px !important'
      },
      '&.Mui-focused': {
        transform: 'translate(28px, 46px) scale(0.75)',
        marginLeft: '-10px !important',
        marginTop: '3px !important'
      }
    }
  },
  '& fieldset': {
    top: 0,
    bottom: -5,
    transform: 'rotate(180deg)'
  },
  '& legend': {
    textAlign: 'center'
  },
  '& label': {
    paddingLeft: 6,
    textAlign: 'center',
    '&.MuiInputLabel-shrink': {
      transformOrigin: 'top center'
    },
    '&.MuiFormLabel-filled': {
      padding: 0,
      transform: 'translate(22px, 49px) scale(0.75)'
    },
    '&.Mui-focused': {
      padding: 0,
      transform: 'translate(22px, 49px) scale(0.75)'
    }
  },
  '& input': {
    textAlign: 'center',
    '&::placeholder': {
      textAlign: 'center'
    }
  }
}));

export const DeviationFieldTitle = styled('span', {
  shouldForwardProp: prop => !['hasError', 'hasHint'].includes(prop)
})(({ hasError }) => ({
  position: 'absolute',
  top: -10,
  left: 8,
  padding: 2,
  backgroundColor: '#fff',
  zIndex: 1,
  color: hasError ? '#FF4635' : '#0000008a',
  fontSize: '0.75rem',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
}));

export const TimeFieldsTextError = styled('span')(({ theme }) => ({
  position: 'absolute',
  bottom: -24,
  left: 12,
  margin: 0,
  color: '#FF4635',
  fontSize: '0.75rem',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  [theme.breakpoints.down('sm')]: {
    left: 12,
    bottom: -8,
    margin: 0
  }
}));
